import * as d3 from 'd3';
import moment from 'moment';
import DayAxis from './DayAxis.js';
import Label from './Label.js';
import Row from './Row.js';
import Modal from './Modal.js';
import Tooltip from './Tooltip.js';
import WeekAxis from './WeekAxis.js';
import RowMilestone from './RowMilestone.js';
import RowMilestoneMarker from './RowMilestoneMarker.jsx';
import MilestoneBar from './MilestoneBar.js';

export default class Chart {
  constructor(element, data, options, milestones, onShowEditMilestone) {
    this.element = element;
    this.data = data;
    this.milestones = milestones;
    this.options = options;
    this.components = [];
    this.onShowEditMilestone = onShowEditMilestone;
  }

  set data(data) {
    this._rows = [];

    this._data = data
      .sort((a, b) => a.endDate > b.endDate)
      .map((item) => {
        let row = this._rows.findIndex(
          (latestDate) => item.startDate > latestDate
        );

        if (row < 0) {
          row = this._rows.length;
        }

        this._rows[row] = item.endDate;

        return {
          ...item,
          row,
          startDate: moment(item.startDate).startOf('day').toDate(),
          endDate: moment(item.endDate).endOf('day').toDate(),
        };
      });
  }

  get data() {
    return this._data;
  }

  get rows() {
    return this._rows;
  }

  update() {
    this.components.forEach((component) => component.update());
  }

  rebuild() {
    this.chart.remove();
    this.build();
  }

  buildComponents(components) {
    components.forEach((component, index) => {
      this.components[index] = new component({
        chart: this.chart,
        data: this.data,
        milestones: this.milestones,
        options: this.options,
        rows: this.rows,
        onShowEditMilestone: this.onShowEditMilestone,
      });
      this.components[index].build();
    });
  }

  build() {
    const { width, padding } = this.options;
    const calcHeight = () => this.rows.length * 38 + padding;
    const minHeight = this.options.minHeight || 300;
    const height = Math.max(calcHeight(), minHeight);
    this.options.height = height;

    this.chart = d3
      .select(this.element)
      .append('svg')
      .attr('class', 'chart')
      .attr('width', width)
      .attr('height', height);

    this.buildComponents([
      MilestoneBar,
      DayAxis,
      WeekAxis,
      Row,
      RowMilestone,
      RowMilestoneMarker,
      Label,
      Tooltip,
      Modal,
    ]);
  }
}
